import React from "react"
import {
	Chip
} from "@material-ui/core"

import {
	WABAChannelMessageTemplate,
	WABATemplateStatus,
	WABATemplateCategory
} from "@/@integrations/WABA/protocols/wabaChannelMessageTemplate"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

export const getTemplateStatusChip = (wabaChannelMessageTemplate: WABAChannelMessageTemplate) => {
	const templateStatusToChipConfig: Record<WABATemplateStatus, { title: string, color: string }> = {
		approved: {
			title: "Aprovado",
			color: colors.green[200]
		},
		deactivated: {
			title: "Desativado",
			color: colors.red[100]
		},
		failed: {
			title: "Falhou",
			color: colors.red[100]
		},
		paused: {
			title: "Pausado",
			color: colors.red[100]
		},
		pending: {
			title: "Pendente",
			color: colors.red[100]
		},
		rejected: {
			title: "Rejeitado",
			color: colors.red[100]
		},
		submitted: {
			title: "Submetido",
			color: colors.red[100]
		},
		unknown: {
			title: "Desconhecido",
			color: colors.red[100]
		}
	}

	const chipConfig = templateStatusToChipConfig[wabaChannelMessageTemplate.status] || templateStatusToChipConfig.unknown

	return (
		<Chip
			label={chipConfig.title}
			style={{
				...ColorUtil.getBackgroundAndContrastColor(chipConfig.color),
				cursor: "pointer",
				height: 20
			}}
		/>
	)
}

export const getTemplateCategoryChip = (category: WABATemplateCategory) => {
	const templateCategoryToChipConfig: Record<WABATemplateCategory, { title: string }> = {
		authentication: { title: "Autenticação" },
		marketing: { title: "Marketing" },
		utility: { title: "Utilidade" },
		otp: { title: "OTP" }
	}

	const chipConfig = templateCategoryToChipConfig[category]

	if (!chipConfig) {
		return null
	}

	return (
		<Chip
			label={chipConfig.title}
			style={{
				...ColorUtil.getBackgroundAndContrastColor(colors.purple[100]),
				cursor: "pointer",
				height: 20
			}}
		/>
	)
}
